module.exports = __webpack_public_path__ + "img/success.42b25313.png";